import { rem } from 'polished';
import styled from 'styled-components';
import Config from '@config';
import Heading from '@atoms/Heading/Heading';
import { StyledIconSpan } from '@atoms/Icon/Icon.styles';

export const StyledClosedStoreAlert = styled.div`
  margin-top: ${rem(52)};
`;

export const StyledPromotionPageContent = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: ${rem(20)};
`;

export const IconWrapper = styled.div`
  align-self: center;
  display: flex;
  flex-direction: column;
  margin-top: ${rem(28)};
  gap: ${rem(28)};
  text-align: center;

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    margin-top: ${rem(80)};
    gap: ${rem(40)};
  }

  ${StyledIconSpan} {
    margin: auto;
  }
`;

export const StyledPromotionPageHeading = styled(Heading)`
  margin-top: ${rem(12)};

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    margin-top: ${rem(40)};
  }
`;
